import { topics } from "@/mocks/chaqua";

export default function FeatureTopics() {
  return (
    <section id="topic" className="scroll-mt-20 bg-white py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex flex-col justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-leaf-600">
              <i className="ri-archive-drawer-line" aria-hidden="true"></i>Deep Dive
            </span>
            <h2 className="mt-2 text-2xl font-black text-stone-900 md:text-3xl">深度专题，把瓜吃明白</h2>
            <p className="mt-2 text-sm text-stone-500">不止于热闹，更想带你理解热点背后的逻辑与脉络。</p>
          </div>
        </div>

        <div className="grid gap-5 lg:grid-cols-3">
          {topics.map((t, i) => (
            <article
              key={t.id}
              className={`group relative overflow-hidden rounded-3xl bg-stone-900 ${
                i === 0 ? "lg:col-span-2 lg:row-span-2" : ""
              }`}
            >
              <img
                src={t.img}
                alt={t.title}
                title={`${t.title}｜吃瓜在线深度专题`}
                className={`w-full object-cover object-top opacity-90 transition duration-700 group-hover:scale-105 ${
                  i === 0 ? "aspect-[16/9] lg:h-full lg:min-h-[480px]" : "aspect-[16/9]"
                }`}
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-stone-950/95 via-stone-900/40 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-coral-500 px-2.5 py-1 text-xs font-semibold text-white">
                    <i className="ri-quill-pen-fill" aria-hidden="true"></i>
                    {t.tag}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap rounded-full bg-white/15 px-2.5 py-1 text-xs text-white backdrop-blur-sm">
                    <i className="ri-eye-line" aria-hidden="true"></i>
                    {t.read} 阅读
                  </span>
                </div>
                <h3
                  className={`mt-3 font-black leading-snug text-white ${
                    i === 0 ? "text-xl md:text-3xl" : "text-lg md:text-xl"
                  }`}
                >
                  {t.title}
                </h3>
                <p
                  className={`mt-2 max-w-2xl text-sm leading-relaxed text-stone-300 ${
                    i === 0 ? "line-clamp-2 md:line-clamp-3" : "line-clamp-2"
                  }`}
                >
                  {t.desc}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-coral-300">
                  开始阅读
                  <i className="ri-arrow-right-line transition group-hover:translate-x-1" aria-hidden="true"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}